/* @ngInject */

export default (
  $rootScope,
  helperService,
  expensesService,
  helperPdfService
) => {
  /**
   * Prepare short expenses version.
   *
   * @param {Object} expenses
   * @param {Boolean} isPurchaseOwnerOccupied
   *
   * @returns {Array}
   */
  const prepareShortExpensesVersion = ({ expenses, isPurchaseOwnerOccupied }) => {
    const content = [];
    content.push(helperPdfService.createSubHeader({ title: 'FOOD EXPENSES' }));
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                {
                  text: 'Food & supermarket items\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.foodAndSupermarketItems.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.foodAndSupermarketItemsFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            '',
            '',
            ''
          ],
          [
            {
              text: [
                {
                  text: 'Total monthly food expenses\n',
                  style: 'label'
                },
                {
                  text: expensesService
                    .getTotalFoodExpenses(expenses, false)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ],
              colSpan: 2
            },
            '',
            '',
            ''
          ]
        ]
      },
      layout: 'noBorders'
    });

    content.push(helperPdfService.createSubHeader({ title: 'DISCRETIONARY EXPENSES' }));
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                {
                  text: 'Phone/Internet/Pay TV\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.phoneInternetPayTV.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.phoneInternetPayTVFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Entertainment/Holidays\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.entertainment.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.entertainmentFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Other discretionary expenses\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.other.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.otherFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            ''
          ],
          [
            {
              text: [
                {
                  text: 'Total monthly discretionary expenses\n',
                  style: 'label'
                },
                {
                  text: expensesService
                    .getTotalDiscretionaryExpenses(expenses, false)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ],
              colSpan: 2
            },
            '',
            '',
            ''
          ]
        ]
      },
      layout: 'noBorders'
    });

    content.push(helperPdfService.createSubHeader({ title: 'CHILDREN & EDUCATION EXPENSES' }));
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                {
                  text: 'School fees, uniforms, education\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.schoolFeesUniformsEducation.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.schoolFeesUniformsEducationFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Child care\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.childCare.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.childCareFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            '',
            ''
          ],
          [
            {
              text: [
                {
                  text: 'Total monthly children & education expenses\n',
                  style: 'label'
                },
                {
                  text: expensesService
                    .getTotalChildrenAndEducationExpensesTemporary(expenses)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ],
              colSpan: 2
            },
            '',
            '',
            ''
          ]
        ]
      },
      layout: 'noBorders'
    });

    content.push(helperPdfService.createSubHeader({ title: 'HEALTH & WELLNESS EXPENSES' }));
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                {
                  text: 'Private health insurance\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.privateHealthInsurance.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.privateHealthInsuranceFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Life/Trauma/Income insurance\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.lifeTraumaIncomeInsurances.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.lifeTraumaIncomeInsurancesFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text:
                    helperService.getOrganizationCountry().cca2 === 'NZ'
                      ? 'KiwiSaver\n'
                      : 'Other health & wellness\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.anyOtherInsurances.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.anyOtherInsurancesFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            ''
          ],
          [
            {
              text: [
                {
                  text: 'Total monthly health & wellness expenses\n',
                  style: 'label'
                },
                {
                  text: expensesService
                    .getTotalHealthAndWellnessExpenses(expenses, false)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ],
              colSpan: 2
            },
            '',
            '',
            ''
          ]
        ]
      },
      layout: 'noBorders'
    });

    content.push(helperPdfService.createSubHeader({ title: 'TRANSPORTATION EXPENSES' }));
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                {
                  text: 'Motor vehicle registration & insurance\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.transportation.motorVehicleInsurance.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.transportation.motorVehicleInsuranceFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Fuel/Tolls/Parking\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.transportation.fuelTollsParking.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.transportation.fuelTollsParkingFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Repairs/Servicing/Tyres\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.transportation.repairsServicingTyres.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.transportation.repairsServicingTyresFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            ''
          ],
          [
            {
              text: [
                {
                  text: 'Total monthly transportation expenses\n',
                  style: 'label'
                },
                {
                  text: expensesService
                    .getTotalTransportationExpenses(expenses, false)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ],
              colSpan: 2
            },
            '',
            '',
            ''
          ]
        ]
      },
      layout: 'noBorders'
    });

    content.push(helperPdfService.createSubHeader({ title: 'PROPERTY EXPENSES' }));
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                {
                  text: 'Current rental expenses\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.property.currentRental.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.property.currentRentalFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Electricity/Gas/Water\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.property.electricityGasWater.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.property.electricityGasWaterFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Rates and/or body corp owner occupier\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.property.ratesBodyCorpOwnerOccupied.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.property.ratesBodyCorpOwnerOccupiedFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Rates and/or body corp investment\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.property.ratesBodyCorpInvestment.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.property.ratesBodyCorpInvestmentFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            }
          ],
          [
            {
              text: [
                {
                  text: 'Total monthly property expenses\n',
                  style: 'label'
                },
                {
                  text: expensesService
                    .getTotalPropertyExpenses(expenses, false, isPurchaseOwnerOccupied)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ],
              colSpan: 2
            },
            '',
            '',
            ''
          ]
        ]
      },
      layout: 'noBorders'
    });
    return content;
  };

  /**
   * Prepare long expenses version.
   *
   * @param {Object} expenses
   * @param {Boolean} isPurchaseOwnerOccupied
   *
   * @returns {Array}
   */
  const prepareLongExpensesVersion = ({ expenses, isPurchaseOwnerOccupied }) => {
    const content = [];
    content.push(helperPdfService.createSubHeader({ title: 'FOOD EXPENSES' }));
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                {
                  text: 'Food & supermarket items\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.foodAndSupermarketItems.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.foodAndSupermarketItemsFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Coffee/Lunches/Takeaway\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.coffeeLunchesTakeaway.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.coffeeLunchesTakeawayFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Cigarettes & alcohol\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.cigarettesAndAlcohol.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.cigarettesAndAlcoholFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            ''
          ],
          [
            {
              text: [
                {
                  text: 'Total monthly food expenses\n',
                  style: 'label'
                },
                {
                  text: expensesService
                    .getTotalFoodExpenses(expenses, false)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ],
              colSpan: 2
            },
            '',
            '',
            ''
          ]
        ]
      },
      layout: 'noBorders'
    });

    content.push(helperPdfService.createSubHeader({ title: 'DISCRETIONARY EXPENSES' }));
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                {
                  text: 'Clothing/Shoes/Accessories\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.clothingShoesAccessories.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.clothingShoesAccessoriesFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Phone/Internet/Pay TV\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.phoneInternetPayTV.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.phoneInternetPayTVFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Hairdressing/Grooming\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.hairdressingGrooming.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.hairdressingGroomingFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Entertainment\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.entertainment.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.entertainmentFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            }
          ],
          [
            {
              text: [
                {
                  text: 'Gifts & celebrations\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.giftsAndCelebrations.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.giftsAndCelebrationsFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Holidays\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.holidays.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.holidaysFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Pets: Food/Care/Vet\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.petsFoodCareVet.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.petsFoodCareVetFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Other discretionary expenses\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.other.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.otherFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            }
          ],
          [
            {
              text: [
                {
                  text: 'Total monthly discretionary expenses\n',
                  style: 'label'
                },
                {
                  text: expensesService
                    .getTotalDiscretionaryExpenses(expenses, false)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ],
              colSpan: 2
            },
            '',
            '',
            ''
          ]
        ]
      },
      layout: 'noBorders'
    });

    content.push(helperPdfService.createSubHeader({ title: 'CHILDREN & EDUCATION EXPENSES' }));
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                {
                  text: 'School fees, uniforms, education\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.schoolFeesUniformsEducation.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.schoolFeesUniformsEducationFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Child care\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.childCare.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.childCareFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            '',
            ''
          ],
          [
            {
              text: [
                {
                  text: 'Total monthly children & education expenses\n',
                  style: 'label'
                },
                {
                  text: expensesService
                    .getTotalChildrenAndEducationExpensesTemporary(expenses)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ],
              colSpan: 2
            },
            '',
            '',
            ''
          ]
        ]
      },
      layout: 'noBorders'
    });

    content.push(helperPdfService.createSubHeader({ title: 'HEALTH & WELLNESS EXPENSES' }));
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                {
                  text: 'Gym fees/Sport\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.gymFeesSport.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.gymFeesSportFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Private health insurance\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.privateHealthInsurance.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.privateHealthInsuranceFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Doctor/Dentist/Pharmacy\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.doctorDentistPharmacy.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.doctorDentistPharmacyFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Glasses & eye care\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.glassesAndEyeCare.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.glassesAndEyeCareFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            }
          ],
          [
            {
              text: [
                {
                  text: 'Life/Trauma/Income insurance\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.lifeTraumaIncomeInsurances.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.lifeTraumaIncomeInsurancesFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text:
                    helperService.getOrganizationCountry().cca2 === 'NZ'
                      ? 'KiwiSaver\n'
                      : 'Other health & wellness\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.anyOtherInsurances.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.anyOtherInsurancesFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            '',
            ''
          ],
          [
            {
              text: [
                {
                  text: 'Total monthly health & wellness expenses\n',
                  style: 'label'
                },
                {
                  text: expensesService
                    .getTotalHealthAndWellnessExpenses(expenses, false)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ],
              colSpan: 2
            },
            '',
            '',
            ''
          ]
        ]
      },
      layout: 'noBorders'
    });

    content.push(helperPdfService.createSubHeader({ title: 'TRANSPORTATION EXPENSES' }));
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                {
                  text: 'Motor vehicle insurance\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.transportation.motorVehicleInsurance.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.transportation.motorVehicleInsuranceFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Motor vehicle registration\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.transportation.motorVehicleRegistration.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.transportation.motorVehicleRegistrationFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Fuel/Tolls/Parking\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.transportation.fuelTollsParking.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.transportation.fuelTollsParkingFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Repairs/Servicing/Tyres\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.transportation.repairsServicingTyres.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.transportation.repairsServicingTyresFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            }
          ],
          [
            {
              text: [
                {
                  text: 'Bus/Train/Tram/Ferry\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.transportation.busTrainTramFerry.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.transportation.busTrainTramFerryFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Car share/Uber/Taxi\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.transportation.carShareUberTaxi.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.transportation.carShareUberTaxiFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            '',
            ''
          ],
          [
            {
              text: [
                {
                  text: 'Total monthly transportation expenses\n',
                  style: 'label'
                },
                {
                  text: expensesService
                    .getTotalTransportationExpenses(expenses, false)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ],
              colSpan: 2
            },
            '',
            '',
            ''
          ]
        ]
      },
      layout: 'noBorders'
    });

    content.push(helperPdfService.createSubHeader({ title: 'PROPERTY EXPENSES' }));
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                {
                  text: 'Home & contents insurance\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.property.homeAndContentsInsurance.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.property.homeAndContentsInsuranceFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Electricity/Gas/Water\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.property.electricityGasWater.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.property.electricityGasWaterFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Repairs/Maintenance/Pool\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.property.repairsMaintenancePool.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.property.repairsMaintenancePoolFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Rates and/or body corp owner occupier\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.property.ratesBodyCorpOwnerOccupied.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.property.ratesBodyCorpOwnerOccupiedFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            }
          ],
          [
            {
              text: [
                {
                  text: 'Rates and/or body corp investment\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.property.ratesBodyCorpInvestment.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.property.ratesBodyCorpInvestmentFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ],
              colSpan: 2
            },
            '',
            '',
            ''
          ],
          [
            {
              text: [
                {
                  text: 'Total monthly property expenses\n',
                  style: 'label'
                },
                {
                  text: expensesService
                    .getTotalPropertyExpensesTemporary(expenses)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ],
              colSpan: 2
            },
            '',
            '',
            ''
          ]
        ]
      },
      layout: 'noBorders'
    });

    content.push(helperPdfService.createSubHeader({ title: 'OTHER COMMITMENTS' }));
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                {
                  text: 'Child maintenance\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.personal.childMaintenance.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.personal.childMaintenanceFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            {
              text: [
                {
                  text: 'Current rental expenses\n',
                  style: 'label'
                },
                {
                  text: [
                    {
                      text: expenses.property.currentRental.formatWithCurrency(
                        $rootScope.CurrentCurrency(),
                        0
                      ),
                      style: 'value'
                    },
                    {
                      text: ` (${expenses.property.currentRentalFrequency.title()})`,
                      style: 'valueXS'
                    }
                  ]
                }
              ]
            },
            '',
            ''
          ],
          [
            {
              text: [
                {
                  text: 'Total monthly other commitments expenses\n',
                  style: 'label'
                },
                {
                  text: expensesService
                    .getTotalOtherCommitmentsExpenses(expenses)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ],
              colSpan: 2
            },
            '',
            '',
            ''
          ]
        ]
      },
      layout: 'noBorders'
    });

    content.push(helperPdfService.createSubHeader({ title: 'TOTAL EXPENSES' }));
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                {
                  text: 'Total monthly expenses\n',
                  style: 'label'
                },
                {
                  text: expensesService
                    .getTotalExpenses(expenses, false, isPurchaseOwnerOccupied)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ],
              colSpan: 2
            },
            '',
            '',
            ''
          ]
        ]
      },
      layout: 'noBorders'
    });

    return content;
  };

  /**
   * Prepare expenses details.
   *
   * @param {Object} expenses
   * @param {Array} contacts
   * @param {Boolean} isShortVersion
   * @param {Boolean} isPurchaseOwnerOccupied
   *
   * @returns {Object}
   */
  const prepareExpensesDetails = ({
    expenses,
    contacts,
    isShortVersion,
    isPurchaseOwnerOccupied
  }) => {
    let content = [];
    const personContacts = _.filter(contacts || [], (c) => !c.isCompany);
    if (personContacts.length) {
      const idContacts = _.map(personContacts, 'id');
      const names = helperService.getContactsByContentType({
        contacts: personContacts,
        idContacts,
        contentType: 'name'
      });
      content.push(
        helperPdfService.createHeader({
          title: `EXPENSES - ${names.toUpperCase()}`,
          pageBreak: 'before'
        })
      );
      if (isShortVersion) {
        content = content.concat(
          prepareShortExpensesVersion({ expenses, isPurchaseOwnerOccupied })
        );
      } else {
        content = content.concat(
          prepareLongExpensesVersion({ expenses, isPurchaseOwnerOccupied })
        );
      }
    }
    return content;
  };

  return {
    prepareExpensesDetails
  };
};
